<template lang="pug">
.case-container
  .case-content
    .case-case__title
        .divider
        .title__content
          span {{ $t('案例分享：凯膳怡') }}
          span {{ $t('KitchenAid凯膳怡是拥有百年历史的美国高端厨房家电品牌。') }}
    .case-case__summary
      div
        i.iconfont.iconhangye
        span {{ $t('广告主行业：家用电器') }}

      div
        i.iconfont.iconbumen
        span {{ $t('涉及部门：市场部') }}
    .case-case__content__item
        .content__title {{ $t('案例简介：') }}
        .content {{ $t('增加凯膳怡品牌在搜索引擎中的展现以及为天猫旗舰店进行导流。') }}

    .case-case__content__item
        .content__title {{ $t('客户当前痛点：') }}
        .content {{ $t('凯膳怡近两年进入中国市场，目前需要拓展市场，增加品牌的曝光量与知名度从而进一步的引流至天猫等销售平台，增加产品的销售量。') }}

    .case-case__content__item
        .content__title {{ $t('复歌解决方案：') }}
        .content {{ $t('复歌通过在不同的渠道进行发布口碑内容，提高品牌的口碑以及品牌的曝光量。') }}
        .content 1） {{ $t('软文渠道：在与品牌相符合的门户网站中进行大量的软文发布，每月发布100-150篇。提高百度的收录量，同时增加核心关键词的曝光程度。') }}
        .content 2） {{ $t('百度知道&知乎问答：以第三方的视角，在问答平台对品牌的口碑进行维护。每月发布50组问答内容。') }}
        .content 3） {{ $t('今日头条信息流：以图片广告的形式投放今日头条信息流，对品牌进行大量的曝光。') }}
    .case-case__content__item
        .content__title {{ $t('最终结果：') }}
        .content {{ $t('软文以及问答渠道，在百度搜索前台有大量的展现，品牌曝光量有所提高。今日头条渠道每日为品牌天猫旗舰店带来20万+的流量。') }}
  MobileContact
</template>"
<script>
import MobileContact from '@/components/MobileContact'
export default {
  components: {
    MobileContact
  }
}
</script>
